const TYPES = {
  BUY: 'Buy',
  SELL: 'Sell',
  WITHDRAWAL: 'Withdrawal',
  BALANCE: 'Balance',
};

const TYPES_LIST = [
  {
    id: TYPES.BUY,
    caption: 'Buy',
  },
  {
    id: TYPES.SELL,
    caption: 'Sell',
  },
  {
    id: TYPES.WITHDRAWAL,
    caption: 'Withdrawal',
  },
  {
    id: TYPES.BALANCE,
    caption: 'Balance',
  },
];

const STATUSES = {
  CREATED: 'Created',
  AWAITING: 'Awaiting',
  AWAITING_BLOCKCHAIN: 'AwaitingBlockchain',
  REJECTED: 'Rejected',
  HAS_BALANCE: 'HasBalance',
  EMPTY: 'Empty',
  EXPIRED: 'Expired',
};

const STATUSES_LIST = [
  {
    id: STATUSES.CREATED,
    caption: 'Created',
  },
  {
    id: STATUSES.AWAITING,
    caption: 'Awaiting',
  },
  {
    id: STATUSES.AWAITING_BLOCKCHAIN,
    caption: 'AwaitingBlockchain',
  },
  {
    id: STATUSES.REJECTED,
    caption: 'Rejected',
  },
  {
    id: STATUSES.HAS_BALANCE,
    caption: 'HasBalance',
  },
  {
    id: STATUSES.EMPTY,
    caption: 'Empty',
  },
  {
    id: STATUSES.EXPIRED,
    caption: 'Expired',
  },
];

export default {
  TYPES,
  TYPES_LIST,
  STATUSES,
  STATUSES_LIST,
};
